<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card text-white rounded">
    <!--Name and ID-->
    <div class="card-user-details-section">
      <div class="card-user-details">
        <h3 class="card-name mb-0" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h3>
        <div class="d-flex font-size-12 mb-2 card-details text-secondary">
          <h5>{{ memberCard.ProductCode }}</h5>
          <div class="px-1">-</div>
          <h5>{{ memberCard.ExternalRefNumber }}</h5>
        </div>
      </div>
      <!--Logo-->
      <div class="align-self-center">
        <img alt="" class="card-logo" src="assets/images/rewards/rewards-logo.png" draggable="false" />
      </div>
    </div>

    <div class="card-user-details-section">
      <!-- <ng-container *inPopulation="[populations.Paid]">
        <div class="account-info">
          <div class="discount">{{ 'member.card.discount' | translate }}</div>
          <div class="text-start value">{{ memberCard.RetailDiscountLevel || 0 }}%</div>
        </div>
      </ng-container> -->
      <ng-container *inPopulation="[populations.Paid, populations.Default]">
        <div class="account-info">
          <div class="points">{{ 'member.card.points' | translate }}</div>
          <div class="value text-start">
            {{ pointsBalance$ | async | number : '1.0-0' }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
